
import React from 'react';
import {  Alert, Box, Button, DialogActions, DialogContent, DialogTitle, Grid,  LinearProgress,  Paper } from '@mui/material';
import { useState } from 'react';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import { Relatorios } from '../../../shared/services/api/relatorios/relatorios';
import Relatorioestoque from './relatoriosestoque';
import { AutoCompleteFabrica01 } from '../../../shared/forms/AutoCompleteFabrica01';

export const RelatoriosEstoque: React.FC = () => {                      
  const [isLoading, setIsLoading] = useState(false);         
  const [uuidfabrica, setUidfabrica] = useState('');   
  const [nome, setnome] = useState(''); 
  const [msg, setMsg] = useState('');  
  const [openalert, setOpenAlert] = useState(false); 
              
  const handleSave = () => {                           
    Relatorios             
      .RelatorioEstoque( uuidfabrica)   
      .then((result) => {          
        setIsLoading(false);              
        if (result instanceof Error) { 
          setMsg(result.message); 
          setOpenAlert(true);                              
        }else {   
          if(result.length > 0){   
              Relatorioestoque(result, nome);  
          }else{
            setMsg('Não a Registros');
            setOpenAlert(true);
          }
        }      
         
      });     
  };          
   const handleCloseAlert = (
      event?: React.SyntheticEvent | Event,
      reason?: SnackbarCloseReason,
    ) => {
      if (reason === 'clickaway') {
        return;
      }                        
      setOpenAlert(false);
    };
  const handlefabrica= (uuidfabrica: string | undefined) => {    
    if (uuidfabrica != null) {     
      setUidfabrica(uuidfabrica);                  
    }else{                       
      setUidfabrica('');                         
    }                 
  };  
  const handnome= (nome: string | undefined) => {    
    if (nome!= null) {     
      setnome(nome);                  
    }else{                       
      setnome('');                         
    }                 
  };  
  
    

  return (
    <Box  alignItems="center" width='auto' alignContent='center' height="auto"  display="flex" flexDirection="column"  >
     <Snackbar 
                open={openalert}        
                autoHideDuration={1200}           
                onClose={handleCloseAlert}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}  
              >
            <Alert  
              onClose={handleCloseAlert}        
              severity="error"         
              variant="filled"              
                
              sx={{ width: '100%' }}            
            >         
              {msg}           
            </Alert>         
          </Snackbar>
      <Box gap={1}  padding={1} paddingX={2} display="flex" alignItems="center" alignSelf='center' width='80%' height="20%" margin={1}  alignContent='center'></Box>
      <Box   width='auto' alignItems="center"  component={Paper} height="auto" margin={1} 
      
        alignContent='center'>       
        <DialogTitle>Relatório de Estoque por Fábrica </DialogTitle>
        <DialogContent  dividers>    
          
          {isLoading && (           
            <Grid item>  
              <LinearProgress variant='indeterminate' />  
            </Grid>                      
          )}   
          <Grid container  padding={1} item direction="row" gap={2}>
            <Grid container spacing={2} item direction="row" xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <AutoCompleteFabrica01
                  uuidfabrica={handlefabrica} 
                  nome={handnome}
                />                    
              </Grid>  
           </Grid>        
          </Grid>         
        </DialogContent>     
        <DialogActions>
          <Button sx={{ minWidth:'30%'  }} variant='outlined' autoFocus onClick={handleSave}>Visualizar</Button>
        </DialogActions>
      </Box>
    </Box>
  );
};   